import { render, staticRenderFns } from "./EmailColumn.vue?vue&type=template&id=3ebc7e22&"
import script from "./EmailColumn.vue?vue&type=script&lang=js&"
export * from "./EmailColumn.vue?vue&type=script&lang=js&"
import style0 from "./EmailColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ebc7e22')) {
      api.createRecord('3ebc7e22', component.options)
    } else {
      api.reload('3ebc7e22', component.options)
    }
    module.hot.accept("./EmailColumn.vue?vue&type=template&id=3ebc7e22&", function () {
      api.rerender('3ebc7e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/EmailColumn.vue"
export default component.exports